var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-company"}},[_c('section',{staticClass:"section is-paddingless"},[_c('search-for-candidates')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }